import React, { useEffect, useState, createContext, useContext } from "react";
import firebaseUtil from "./FirebaseUtil";
import { AuthContext } from "../authentication/Auth";
import app from "../authentication/firebaseStart";
import { DLR_MACHINE_LEARNING } from './constants';
import {
  ENABLE_BT_SCANNER_TRACKING
} from "../data/application.properties";
export const DataContext = createContext();
export const useDataContext = () => useContext(DataContext);

export function DataProvider({ children }) {

  const [about, setAbout] = useState({
    serverVersion: "",
  });
  const [globalAppSettings, setGlobalAppSettings] = useState({});
  const [currentUserObj, setCurrentUserObj] = useState({});
  const [dlrFeatureFlag, setDlrFeatureFlag] = useState(false);
  const [mlPredictionStatus, setMlPredictionStatus] = useState(false);
  const firestore = app.firestore();
  const context = useContext(AuthContext);
  useEffect(() => {
    getAbout();
    getSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function getAbout() {
    let response = await firebaseUtil.getServerVersion();
    setAbout({ ...about, serverVersion: response.msg });
  }

  async function getSettings() {
    let companyID = context.currentUser.claims.companyID;
    let currentUserEmail = context.currentUser.email;

    let findCurrentUserObj = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('Users')
        .where('emailId', '==', currentUserEmail)
        // .where('displayApMacAddress', '==', value.toUpperCase())
        .get()
    ).docs.map((doc) => doc.data());
    setCurrentUserObj(findCurrentUserObj[0])

    let data = (
      await firestore
        .collection("tenants")
        .doc(companyID)
        .collection("Configuration")
        .doc("AppSettings")
        .get()
    ).data();

    if (data) {
    console.log('data in datacontext :', data);
    if(data.featureToggling?.dlrPrediction && data.featureToggling?.dlrPrediction == 1){
      setDlrFeatureFlag(true);
      try{
        const mlStatus = (
          await firestore
              .collection('tenants')
              .doc(companyID)
              .collection('Configuration')
              .doc('AppSettings')
              .collection("DLRSettings")
              .doc("DLRConfig")
              .get()
        ).data();
        if(mlStatus?.MLPredictionStatus===DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE){
          setMlPredictionStatus(true);
        }
        else{
          setMlPredictionStatus(false);
        }
      }
      catch(err){
        setMlPredictionStatus(false);
      }
    }
    setFeatureToggling(data);
    setGlobalAppSettings({
        checkin: data.checkinStatus,
        prefix: data.checkoutBarcodePrefix,
        globalSupervisor: data.globalSupervisorEnabled,
        maxCheckoutTime: data.maxCheckoutTime,
        deviceCheckinOption: data.deviceCheckinOption,
        deviceRegistrationType: data.deviceRegistrationType,
        workFlowData: data,
        userRoleSettings:data.userRoleSettings,
        enableLostDeviceSettings: data.enableLostDeviceSettings,
        lostDeviceNotificationSettings: data.lostDeviceNotificationSettings,
        enableGPSLocation: data.enableGPSLocation,
        GPSLocationSettings: data.GPSLocationSettings,
        reportingFrequency : data.reportingFrequency,
        btTrackerSettings: data.btTrackerSettings,
        featureToggling : data.featureToggling,
        enableBTScannerTracking: data.enableBTScannerTracking
      });
      
    }
  }

  function setFeatureToggling(data){
    if(data?.featureToggling?.btScannerTracking===1){
      ENABLE_BT_SCANNER_TRACKING = true;
    }else if(data?.featureToggling?.btScannerTracking===0){
      ENABLE_BT_SCANNER_TRACKING = false;
    }
  }

  return (
    <DataContext.Provider value={{ about, globalAppSettings, setGlobalAppSettings, currentUserObj, dlrFeatureFlag, mlPredictionStatus, setMlPredictionStatus }}>
      {children}
    </DataContext.Provider>
  );
}